import React from 'react';
import Slider, { CustomArrowProps } from 'react-slick';
import { ImageResizer } from '../../Types/ImageResizer';

import { ReactComponent as CircleArrowRightIcon } from '../Icons/circleArrowRight.svg';
import { ReactComponent as CircleArrowLleftIcon } from '../Icons/circleArrowLeft.svg';

import './HowDoWeDo.scss';
import Media from 'react-media';
import { useSessionStorage } from '../../hooks/useSessionStorage';

interface Tile {
	text: string;
	textUa: string;
	image: ImageResizer;
}

interface HowDoWeDoProps {
	title: string;
	titleUa: string;
	tiles: Tile[];
}

const PrevArrow = ({ onClick }: CustomArrowProps) => {
	return (
		<div className="leftArrow" onClick={onClick}>
			{' '}
			<CircleArrowLleftIcon />{' '}
		</div>
	);
};

const NextArrow = ({ onClick }: CustomArrowProps) => {
	return (
		<div className="rightArrow" onClick={onClick}>
			{' '}
			<CircleArrowRightIcon />{' '}
		</div>
	);
};

export default function HowDoWeDo({ title, titleUa, tiles }: HowDoWeDoProps) {
	const [language] = useSessionStorage('language', '');

	const settings = {
		className: 'center',
		centerMode: true,
		infinite: true,
		dots: true,
		autoplay: true,
		autoplaySpeed: 10000,
		centerPadding: '0px',
		slidesToShow: 1,
		speed: 500,
		prevArrow: <PrevArrow />,
		nextArrow: <NextArrow />,
	};
	return (
		<Media query="(max-width: 768px)">
			{(matches) => (
				<div className="howDoWeDoItContent">
					{matches && <div className="howDoWeDoItTitle">{language === 'ua' ? titleUa : title}</div>}
					<Slider {...settings}>
						{tiles.map((tile, index) => (
							<div key={index} className="howDoWeDoItTile">
								<div className="howDoWeDoItImageShadow">
									<div
										className="howDoWeDoItImage"
										style={{
											backgroundImage: tile.image && `url(${tile.image.md.src})`,
										}}
									/>
								</div>
								<div className="howDoWeDoItTileContentWrapper">
									{!matches && <div className="howDoWeDoItTitle">{language === 'ua' ? titleUa : title}</div>}

									<div key={index} className="howDoWeDoItTileContent">
										<div className="howDoWeDoItTileText">{language === 'ua' ? tile.textUa : tile.text}</div>
									</div>
								</div>
							</div>
						))}
					</Slider>
				</div>
			)}
		</Media>
	);
}
